<template>
  <div></div>
</template>

<script>
import helpers from "@/helpers"
import { baseApiUrl } from "@/global"
import axios from "axios"
import xlsx from "xlsx"

export default {
  data() {
    return {
      data: [],
      products: []
    }
  },
  methods: {
    async generate(filters) {
      this.orders = []
      this.filters = filters
      this.helpers = helpers

      if (!this.filterProducts()) {
        return false
      }

      this.fixVarsToTable()
      this.makeXLSX()
      return true
    },
    filterProducts() {
      let products = this.$store.state.products
      if (this.filters.codigo.length)
        products = products.filter(product => this.filters.codigo.includes(product.codigo))
      if (this.filters.marca.length)
        products = products.filter(product => this.filters.marca.includes(product.marca))
      if (this.filters.modelo.length)
        products = products.filter(product => this.filters.modelo.includes(product.modelo))

      this.data = products
      return products.length
    },
    fixVarsToTable() {
      for (const product of this.data) {
        this.products.push({
          "Código": product.codigo,
          "Descrição EN/US": product.descricaoEN,
          "Modelo": product.modelo,
          "Marca": product.marca,
          "Regnaparts": product.estoqueRegnaparts,
          "Regnaparts Reservado": product.estoqueRegnapartsReservado,
          "Regnaparts Contado": '',
          "Regnaparts Vendido": '',
          "Revestebem": product.estoqueRevestebem,
          "Revestebem Reservado": product.estoqueRevestebemReservado,
          "Revestebem Contado": '',
          "Revestebem Vendido": '',
          "Total Webmais": product.estoqueRegnaparts +
            product.estoqueRevestebem +
            product.estoqueRegnapartsReservado +
            product.estoqueRevestebemReservado,
          "Total Contado": '',
        })
      }
    },
    XLSXfitColumns(json, worksheet) {
      const jsonKeys = Object.keys(json[0]);

      let objectMaxLength = [];
      for (let i = 0; i < json.length; i++) {
        let value = json[i];
        for (let j = 0; j < jsonKeys.length; j++) {
          if (typeof value[jsonKeys[j]] == "number") {
            objectMaxLength[j] = 10;
          } else {

            const l = value[jsonKeys[j]] ? value[jsonKeys[j]].length : 0;

            objectMaxLength[j] =
              objectMaxLength[j] >= l ?
              objectMaxLength[j] :
              l;
          }
        }

        let key = jsonKeys;
        for (let j = 0; j < key.length; j++) {
          objectMaxLength[j] =
            objectMaxLength[j] >= key[j].length ?
            objectMaxLength[j] :
            key[j].length;
        }
      }
      const wscols = objectMaxLength.map(w => { return { width: w + 1 } });
      worksheet["!cols"] = wscols
    },
    makeXLSX() {
      const worksheet = xlsx.utils.json_to_sheet(this.products)
      this.XLSXfitColumns(this.products, worksheet)
      const workbook = xlsx.utils.book_new()
      xlsx.utils.book_append_sheet(workbook, worksheet, 'Planilha 1')
      xlsx.writeFile(workbook, 'Relatorio_Estoque.xlsx')
    }
  }
}

</script>
